import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import MetaInfo from 'vue-meta-info'
const app = createApp(App);

app.use(router);
app.use(MetaInfo)
app.mount('#app');
setTimeout(() => {
  document.dispatchEvent(new Event('render-event'))
}, 500)

/* // 新增：触发渲染事件
 * document.dispatchEvent(new Event('render-event')); */
